/* A Features menu in the header, on every page. v2.

   WHAT CHANGED FROM v1. Eight pages, not six: Rockkt One and Playbooks joined
   the list, and the panel grew a fourth row. Same order as the band at the foot
   of the homepage (rockkt-router-v5.js) and the footer column
   (rockkt-footer-sync-v3.js). Change them in all three or in none.

   Playbooks points at /pages/send-playbooks, not /pages/playbooks: that handle
   belongs to the guides hub, which is content rather than product.

   WHY AT RUN TIME. Two different header snippets are in play -
   rockkt-home-shell-v2 on the section pages, and rockkt-page-head on the
   twenty-odd inner pages - and three hand-built templates carry their own copy
   inside files the Admin API will not replace as text. They all share one shape
   though: header.nav > .nav-cta with the Pricing link first, and #navMobile
   with the Pricing link first. So one script finds that Pricing link and puts
   Features immediately before it, in both places. Same route
   rockkt-ccy-top-v3.js takes for the currency pill, which is why the row reads:
   currency, Features, Pricing, Sign in, Join Rockkt.

   ICONS ARE INLINE, NOT SPRITE REFERENCES. The inner pages' sprite carries five
   symbols, none of them the eight this needs, so <use href="#g-gift"> would
   draw nothing there. The paths are the same ones as the homepage sprite,
   copied in.

   The desktop panel opens on hover and on click (touch laptops), closes on
   mouse-out, outside click and Escape, and announces itself with aria-expanded.
   Under the burger breakpoint .nav-cta is hidden by the page's own CSS and the
   menu goes with it; the mobile group takes over. */
(function () {
  var ICON = {
    click:    '<path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51z"/><path d="M13 13l6 6"/>',
    list:     '<path d="M8 6h13"/><path d="M8 12h13"/><path d="M8 18h13"/><path d="M3 6h.01"/><path d="M3 12h.01"/><path d="M3 18h.01"/>',
    gift:     '<path d="M20 12v10H4V12"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>',
    sparkles: '<path d="M12 3l1.8 4.7L18.5 9.5 13.8 11.3 12 16l-1.8-4.7L5.5 9.5 10.2 7.7z"/><path d="M19 14l.6 1.6 1.6.6-1.6.6L19 19l-.6-1.6-1.6-.6 1.6-.6z"/>',
    rocket:   '<path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4z"/>',
    chart:    '<path d="M18 20V10"/><path d="M12 20V4"/><path d="M6 20v-6"/>',
    compass:  '<circle cx="12" cy="12" r="10"/><path d="M16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36z"/>',
    shield:   '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/>'
  };

  /* Same eight, same order and same one-liners as the band at the foot of the
     homepage (rockkt-router-v5.js). Change them in both places or in neither. */
  var PAGES = [
    ['/pages/rockkt-one',     'click',    'Rockkt One',    'Send from any LinkedIn profile, without leaving it'],
    ['/pages/send-playbooks', 'list',     'Playbooks',     'Prewrite the send, fire it in twenty seconds'],
    ['/pages/gift-lab',       'gift',     'Gift Lab',      'Any gift, packed, boxed and posted'],
    ['/pages/design-studio',  'sparkles', 'Design Studio', 'Your brand, down to the box on the desk'],
    ['/pages/flight-deck',    'rocket',   'Flight Deck',   'Personalised landing pages, built in minutes'],
    ['/pages/tracking',       'chart',    'Tracking',      'Every send and every signal, in real time'],
    ['/pages/navigator',      'compass',  'Navigator',     'Prospects, sequences and next steps'],
    ['/pages/compliance',     'shield',   'Compliance',    'Caps, approvals and a full audit trail']
  ];

  function svg(name, cls) {
    return '<svg class="' + cls + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
           'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICON[name] + '</svg>';
  }

  function pricingLink(root) {
    if (!root) return null;
    var links = root.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      if (/\/pages\/pricing(\/|$|\?)/.test(links[i].getAttribute('href') || '')) return links[i];
    }
    return null;
  }

  function here(href) {
    return location.pathname.replace(/\/$/, '') === href;
  }

  /* ---- desktop ---- */
  function buildDesktop() {
    var head = document.querySelector('header');
    var link = pricingLink(head && head.querySelector('.nav-cta') || head);
    if (!link || !link.parentNode) return;
    var wrap = document.querySelector('.rk-feat');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'rk-feat';
      wrap.innerHTML =
        '<button type="button" class="nav-link rk-feat-btn" aria-haspopup="true" aria-expanded="false">Features' +
          '<svg class="rk-feat-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>' +
        '</button>' +
        '<div class="rk-feat-menu" role="menu" aria-label="Features">' +
          PAGES.map(function (p) {
            return '<a class="rk-feat-item' + (here(p[0]) ? ' is-here' : '') + '" role="menuitem" href="' + p[0] + '">' +
                     '<span class="rk-feat-ic">' + svg(p[1], 'rk-feat-svg') + '</span>' +
                     '<span class="rk-feat-txt"><b>' + p[2] + '</b><span>' + p[3] + '</span></span>' +
                   '</a>';
          }).join('') +
        '</div>';

      var btn = wrap.querySelector('.rk-feat-btn'), closeT = null;
      function open()  { wrap.classList.add('open');    btn.setAttribute('aria-expanded', 'true');  }
      function close() { wrap.classList.remove('open'); btn.setAttribute('aria-expanded', 'false'); }
      function isOpen(){ return wrap.classList.contains('open'); }

      btn.addEventListener('click', function (e) { e.preventDefault(); isOpen() ? close() : open(); });
      wrap.addEventListener('mouseenter', function () { if (closeT) clearTimeout(closeT); open(); });
      wrap.addEventListener('mouseleave', function () { closeT = setTimeout(close, 160); });
      wrap.addEventListener('focusout', function (e) { if (!wrap.contains(e.relatedTarget)) close(); });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) { close(); btn.focus(); } });
    }
    /* Always directly before Pricing. Idempotent: the currency pill inserts
       itself before Pricing too, on its own timer, so this is re-run after it. */
    if (wrap.nextElementSibling !== link || wrap.parentNode !== link.parentNode) {
      link.parentNode.insertBefore(wrap, link);
    }
  }

  /* ---- burger menu ---- */
  function buildMobile() {
    var menu = document.getElementById('navMobile') || document.querySelector('.nav-mobile');
    var link = pricingLink(menu);
    if (!link || !link.parentNode) return;
    if (menu.querySelector('.rk-feat-mob')) return;
    var g = document.createElement('div');
    g.className = 'rk-feat-mob';
    g.innerHTML = '<span class="rk-feat-mob-h">Features</span>' +
      PAGES.map(function (p) {
        return '<a href="' + p[0] + '"' + (here(p[0]) ? ' aria-current="page"' : '') + '>' + svg(p[1], 'rk-feat-mob-svg') + p[2] + '</a>';
      }).join('');
    link.parentNode.insertBefore(g, link);
  }

  function build() { buildDesktop(); buildMobile(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
  /* rockkt-ccy-top-v3.js rebuilds the header at load + 500ms; settle after it. */
  window.addEventListener('load', function () { setTimeout(build, 650); });
})();
